import { StarFilledIcon } from "@radix-ui/react-icons";

interface RatingProps {
  rating: number;
}

export function Rating({ rating }: RatingProps) {
  return (
    <div className="flex items-center gap-0.5">
      {[...Array(5)].map((_, i) => (
        <StarFilledIcon
          key={i}
          className={`h-5 w-5 ${i < rating ? "text-yellow-500" : "text-gray-300"}`}
        />
      ))}
    </div>
  );
}
